import { downloadAppLinks } from "@widgets/footer/download-app/constants";
import { ApkIcon } from "@shared/ui/Icon/ui/mobile-stores/apk-icon";
import { AppGalleryIcon } from "@shared/ui/Icon/ui/mobile-stores/app-gallery-icon";
import { AppStoreIcon } from "@shared/ui/Icon/ui/mobile-stores/app-store-icon";
import classes from "./download-app.module.scss";

export const DownloadApp = () => {
    return (
        <div className={classes["download-app"]}>
            <label className={classes["download-app__label"]}>Загрузите приложение LIKVI</label>
            <div className={classes["download-app__links"]}>
                <a
                    href={downloadAppLinks.ios.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={downloadAppLinks.ios.label}
                >
                    <AppStoreIcon className={classes["download-app__icon"]} />
                </a>
                <a
                    href={downloadAppLinks.appGallery.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={downloadAppLinks.appGallery.label}
                >
                    <AppGalleryIcon className={classes["download-app__icon"]} />
                </a>
                <a
                    href={downloadAppLinks.apk.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={downloadAppLinks.appGallery.label}
                >
                    <ApkIcon className={classes["download-app__icon"]} />
                </a>
            </div>
        </div>
    );
};